import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableProps = ComponentProps<'table'>;

const Table = ({ className, ...props }: TableProps) => {
  return (
    <div data-slot="table-container" className="relative w-full overflow-x-auto overflow-y-hidden">
      <table
        data-slot="table"
        className={cn('w-full caption-bottom text-xs', className)}
        {...props}
      />
    </div>
  );
};

export default Table;
